import { render } from "./GettersTest.vue?vue&type=template&id=137ee2a4&scoped=true"
import script from "./GettersTest.vue?vue&type=script&lang=js"
export * from "./GettersTest.vue?vue&type=script&lang=js"

import "./GettersTest.vue?vue&type=style&index=0&id=137ee2a4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Hedde\\OneDrive\\UU\\. Honours\\opera-visualisation\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-137ee2a4"]])

export default __exports__